import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ButtonCta1 from "../button/ButtonCta1";
import {
  BASE_URL,
  OCP_APIM_SUBSCRIPTION_KEY,
  toastConfig,
} from "../../constants/constant";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddButtonDisabled,
  setButtonAction,
  setHeader,
  setUpdateButtonDisabled,
} from "../../reduxSlices/headerSlice";
import CommonDialog from "../dialog/CommonDialog";
import ContentLoader from "../loader/ContentLoader";
import { getOrganisationMaster } from "../../reduxSlices/organisationSlice";
import {
  getAllVfAdminReport,
  getReportMaster,
  getReportMasterById,
  getWorkspaceDetailsById,
} from "../../reduxSlices/packageSlice";
import { CustomTextField, isPbixFile } from "../../helpers/helper";
import axios from "axios";
import FileUpload from "../fileupload/FileUpload";
import CustomAutocomplete from "../autocomplete/Autocomplete";

const service = new Service();

const CreateReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { reportId } = useParams();
  const [open, setOpen] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formState, setFormState] = useState({
    reportDetails: {
      reportId: "",
      reportName: "",
    },
    groupId: "",
    profileId: "",
    report: null,
    organization: {
      organizationId: "",
      organizationName: "",
    },
  });

  const buttonAction = useSelector((state) => state?.header?.buttonAction);
  const organisationMaster = useSelector(
    (state) => state.organization.organisationMaster
  );
  const reportMaster = useSelector((state) => state?.package?.reportMaster);
  const workspaceDetails = useSelector(
    (state) => state?.package?.workspaceDetails
  );
  const allVfAdminReport = useSelector(
    (state) => state?.package?.allVfAdminReport
  );
  const isPbix = selectedFile?.name && isPbixFile(selectedFile?.name || "");
  console.log("isPbix", isPbix);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const areInputsFilled = () => {
    return (
      formState?.reportDetails?.reportName?.trim() !== "" &&
      formState?.organization?.organizationName?.trim() !== "" &&
      isPbix &&
      formState?.report?.name
    );
  };
  const inputFilled = areInputsFilled();

  const handleInputFocus = () => {
    if (!reportId) return;
    console.log("User clicked on the input text.");
    dispatch(setUpdateButtonDisabled(inputFilled));
  };

  const getVfReportData = async () => {
    const obj = {
      searchText: "",
      organization: [],
    };
    await dispatch(getAllVfAdminReport(obj));
  };

  useEffect(() => {
    if (!reportId) return;
    getVfReportData();
  }, [reportId]);

  useEffect(() => {
    if (!allVfAdminReport && !reportId) return;
    if (allVfAdminReport && reportId) {
      const filterReport = allVfAdminReport?.filter(
        (item, i) => item?.pbReportId == reportId
      );
      console.log("filterReport", filterReport);
      filterReport?.map((item) => setFormState({ ...item }));
    }
  }, [reportId, allVfAdminReport]);

  useEffect(() => {
    console.log("formState>>>>", formState);
  }, [formState]);

  useEffect(() => {
    if (!reportId) {
      console.log("inputFilled>>>>", inputFilled);
      dispatch(setAddButtonDisabled(inputFilled));
    } else {
      dispatch(setUpdateButtonDisabled(inputFilled));
    }
  }, [inputFilled]);

  useEffect(() => {
    dispatch(
      setHeader({
        page: !reportId ? "add-report" : "edit-report",
        title: !reportId ? "Add Report" : "Edit Report",
        subTitle: !reportId
          ? "Please fill all the mandatory details to fetch and add report in the database"
          : "Please update report details if there are any discrepancies",
      })
    );
    dispatch(getOrganisationMaster());
    // dispatch(getReportMaster());
  }, []);

  useEffect(() => {
    if (formState?.organization?.organizationId) {
      const obj = {
        organizationId: formState?.organization?.organizationId,
      };
      dispatch(getReportMasterById(obj));
      dispatch(getWorkspaceDetailsById(obj));
    }
  }, [formState?.organization?.organizationId]);

  useEffect(() => {
    if (
      (buttonAction.page === "add-report" && buttonAction.action === "add") ||
      (buttonAction.page.includes("edit-report") &&
        buttonAction.action === "update")
    ) {
      console.log("buttonAction called");
      handleSubmit();
    }
    if (
      (buttonAction.page === "add-report" &&
        buttonAction.action === "cancel") ||
      (buttonAction.page.includes("edit-report") &&
        buttonAction.action === "cancel")
    ) {
      console.log("buttonAction called");
      handleClickOpen();
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  useEffect(() => {
    setFormState({
      ...formState,
      groupId: workspaceDetails.pbGroupId,
      profileId: workspaceDetails.pbProfileId,
    });
  }, [workspaceDetails]);

  useEffect(() => {
    console.log("selectedFile", selectedFile);
    setFormState({
      ...formState,
      report: selectedFile,
    });
  }, [selectedFile]);

  const handleOrganizationChange = (e) => {
    console.log("vdvjdvjd", e);
    const { name, value, files } = e.target;
    if (name === "report") {
      const selectedFile = e.target.files[0];
      setFormState({ ...formState, [name]: selectedFile });
    } else {
      setFormState({ ...formState, [name]: value });
    }
  };

  const handleAutoCompleteChange = (name, value) => {
    setFormState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleGoBack = () => {
    navigate(-1);
    setOpen(false);
  };

  const handleSubmit = () => {
    if (!reportId) {
      createReport();
    } else {
      updateReport();
    }
  };

  const createReport = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ReportId", formState.reportDetails.reportId);
    formData.append("ReportName", formState.reportDetails.reportName);
    formData.append("GroupId", formState.groupId);
    formData.append("ProfileId", formState.profileId);
    formData.append("Report", formState.report);
    formData.append("OrganizationId", formState.organization.organizationId);
    console.log("formData>>>", formData);
    let url = `${BASE_URL}/api/Report/AddReport`;
    const user_token = localStorage.getItem("bb_access_token");
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Ocp-Apim-Subscription-Key": OCP_APIM_SUBSCRIPTION_KEY,
        Authorization: "Bearer  " + user_token,
      },
    };
    try {
      let data = await axios.post(url, formData, config);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        toast.success("New report has been added", {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        navigate("/reports");
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const updateReport = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("PbReportId", formState.pbReportId);
    formData.append("ReportId", formState.reportDetails.reportId);
    formData.append("ReportName", formState.reportDetails.reportName);
    formData.append("GroupId", formState.groupId);
    formData.append("ProfileId", formState.profileId);
    formData.append("Report", formState.report);
    formData.append("OrganizationId", formState.organization.organizationId);
    console.log("formData>>>", formData);
    let url = `${BASE_URL}/api/Report/UpdateReport`;
    const user_token = localStorage.getItem("bb_access_token");
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Ocp-Apim-Subscription-Key": OCP_APIM_SUBSCRIPTION_KEY,
        Authorization: "Bearer  " + user_token,
      },
    };
    try {
      let data = await axios.put(url, formData, config);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        toast.success("Report details has been updated", {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        navigate("/reports");
        setLoader(false);
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const getOrgLabel = (option) => option?.organizationName;
  const getReportLabel = (option) => option?.reportName;

  if (loader) return <ContentLoader />;

  return (
    <>
      <div
        style={{
          borderRadius: "12px",
          backgroundColor: "#fff",
          padding: "32px 32px 10px 0",
        }}
      >
        <Box
          component="form"
          sx={{
            "& > :not(style)": { marginBottom: "20px", width: "550px" },
          }}
          noValidate
          autoComplete="off"
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Organisation<sup style={requiredAr}>*</sup>
            </label>
            {console.log("test>>>>", formState?.organization)}
            <CustomAutocomplete
              disabled={!reportId ? false : true}
              options={organisationMaster}
              value={formState?.organization}
              onChange={(e, value) =>
                handleAutoCompleteChange("organization", value)
              }
              getOptionLabel={getOrgLabel}
              onFocus={handleInputFocus}
              placeholder="Select organisation"
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Report Name<sup style={requiredAr}>*</sup>
            </label>
            <CustomAutocomplete
              disabled={!reportId ? false : true}
              options={reportMaster}
              value={formState?.reportDetails}
              onChange={(e, value) =>
                handleAutoCompleteChange("reportDetails", value)
              }
              getOptionLabel={getReportLabel}
              onFocus={handleInputFocus}
              placeholder="Select report"
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Upload Report<sup style={requiredAr}>*</sup>
            </label>
            <FileUpload
              selectedFile={selectedFile}
              setSelectedFile={setSelectedFile}
              formState={formState}
              setFormState={setFormState}
            />
            <Typography
              sx={{
                fontSize: "12px",
                letterSpacing: "-0.02em",
                lineHeight: "16px",
                fontWeight: !isPbix && selectedFile?.name ? 600 : 500,
                fontFamily: "Montserrat",
                color: !isPbix && selectedFile?.name ? "#a50218" : "#8a8a8a",
                textAlign: "left",
                paddingTop: "8px",
              }}
            >
              {(isPbix || !selectedFile?.name) && "Supported Format: .pbix"}
              {!isPbix &&
                selectedFile?.name &&
                "Unsupported File Type! Please upload the file in .pbix format only"}
            </Typography>
          </Box>
        </Box>
      </div>

      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleGoBack}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
    </>
  );
};

export default CreateReport;

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};
